import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=223d4375&"
import script from "./ErrorView.vue?vue&type=script&lang=ts&"
export * from "./ErrorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ErrorView.vue"
export default component.exports